


















import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import { AnnounceItem } from './type';
import { filterData, getAnnounceData } from './business';
import { biClick } from '@tencent/fit-bi-sdk';

@Component
export default class LoopAnnounce extends Vue {
  /** 外部直接传入数据 */
  @Prop() dataList?: AnnounceItem[];
  /** 外部传入url，由内部请求数据 */
  @Prop() dataUrl?: string;

  /** 字体颜色，默认#FA9D3B */
  @Prop({ default: '#FA9D3B' }) fontColor!: string;
  /** 滚动方向, up: 往上滚动|down: 往下滚动|left: 往左滚动|right: 往右滚动，默认up */
  @Prop({ default: 'up' }) direction!: string;
  /** 过渡时间(毫秒)，默认2500 */
  @Prop({ default: 2500 }) duration!: number;


  /** 数据 */
  private list: AnnounceItem[] = [];
  /** 当前索引 */
  private currentIndex = 0;

  /** 有数据才展示UI */
  public get isShow(): boolean {
    return this.list.length > 0;
  }
  /** 当前值 */
  public get currentItem(): AnnounceItem {
    // 初始时，currentItem没有被用到（list为空时，DOM没渲染），不会计算
    // 也就是，不存在这种情况：list = []; currentIndex = 0; list[currentIndex] undefined
    const item = this.list[this.currentIndex];

    return item;
  }

  /** 需要watch dataList，避免是异步传入的 */
  @Watch('dataList')
  public watchDataList(nList) {
    if (!this.dataUrl) {
      this.list = filterData(nList);
    }
  }
  /** watch list，有数据后，开始轮播 */
  @Watch('list')
  public watchList(nVal) {
    if (nVal.length > 0) {
      setTimeout(() => {
        this.beginLoop();
      }, this.duration);
    }
  }

  public async mounted() {
    if (this.dataUrl) {
      // 优先用url请求的数据
      this.list = await getAnnounceData(this.dataUrl);
    } else {
      this.list = filterData(this.dataList || []);
    }
  }
  // ------ 事件start -------
  @Emit('click')
  public handleClick() {
    biClick('loop-announce.item-click|点击文案', {
      fannouncetag: this.currentItem.biTag,
    });
    return this.currentItem;
  }
  // ------ 事件end ---------
  /** 开始循环 */
  private beginLoop() {
    // 2500ms是当前元素停留时间
    const timeout = 2500 + this.duration;
    if (this.currentIndex === this.list.length - 1) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = this.currentIndex + 1;
    }
    setTimeout(() => {
      this.beginLoop();
    }, timeout);
  }
}
